import React, { Component } from 'react'
import InputRow from './InputRow'
import { emailCheck, pwdCheck, handleAlphabetCheck,handleNumberOnlyCheck } from '../constants'
import PropTypes from 'prop-types'
import submit from '../submit.gif'
import logo from '../logo.gif'

export default class Signup extends Component {
  constructor(props) {
    super(props)
    this.state = {
      fname: '',
      lname: '',
      email: '',
      phonenb: '',
      pwd: '',
      cnfPwd: '',
      error: '',
      saveProcessing: false
    }
    this.handleRegister = this.handleRegister.bind(this)
  }

  componentDidMount() {
    const id = sessionStorage.getItem('id')
    const token = sessionStorage.getItem('token')
    if (id && token) {
      const { history } = this.props
      history.replace('/')
    }
  }

  handleRegister() {
    this.setState({ saveProcessing: true })
    const { fname, lname, email,phonenb, pwd, cnfPwd } = this.state
    if (fname && lname && email && phonenb && pwd && cnfPwd) {
      if (pwd === cnfPwd) {
        if (emailCheck.test(email)) {
          if (pwdCheck.test(pwd)) {
            fetch(`${process.env.REACT_APP_API_URL}/api/SignUp/CreateUser`, {
              method: 'POST',
              body: JSON.stringify({
                FirstName: fname,
                LastName: lname,
                Email: email,
                Password: pwd,
                PhoneNumber:phonenb
              }),
              headers: {
                'Content-Type': 'application/json'
              }
            })
              .then(res => res.json())
              .then(res => {
                if (res.StatusCode === 200) {
                 /* sessionStorage.setItem('token', res.Data.Token)
                  sessionStorage.setItem('id', parseInt(res.Data.IncompleteApplicationId))
                  const currentDate = new Date()
                  currentDate.setSeconds(currentDate.getSeconds() + 3600000)
                  sessionStorage.setItem('expiry', currentDate)
                  sessionStorage.setItem('isBlocking', false)
                  sessionStorage.setItem('email', email)
                 // this.props.onLogin(email, res.Data.IncompleteApplicationId, res.Data.Token)
                  const { history } = this.props
                  history.replace('/')*/
                  this.setState({ saveProcessing: false })
                  this.setState({ error: 'An email verification is sent to your email address, verify your account to proceed with the application.',pwd:'',cnfPwd:'',fname:'',lname:'',phonenb:'',email:'' })
                } else {
                  this.setState({ error: res.Msg, pwd: '', cnfPwd: '' })
                  this.setState({ saveProcessing: false })
                }
              })
              .catch(err => {
                console.log(err)
                this.setState({ saveProcessing: false })
                this.setState({ error: 'Network Error. Please try again in sometime', pwd: '', cnfPwd: '' })
              })
          } else {
            this.setState({ saveProcessing: false })
            this.setState(
              {
                error: 'Please Enter a password which at least has 1 character and 1 number with a minimum length of 8 and maximum of 15.The password should be greater than 7 characters, containing at least 1 number and at least 1 special (non-alphanumeric) character.', pwd: '', cnfPwd: ''
              }
            )
          }
        } else {
          this.setState({ saveProcessing: false })
          this.setState(
            {
              error: 'Please Enter a Valid Email Address', pwd: '', cnfPwd: ''
            }
          )
        }
      } else {
        this.setState({ saveProcessing: false })
        this.setState({ error: 'Passwords do not match!', pwd: '', cnfPwd: '' })
      }
    } else {
      this.setState({ saveProcessing: false })
      this.setState({ error: 'Please fill up all required fields', pwd: '', cnfPwd: '' })
    }
  }

  render() {
    const { fname, lname, email,phonenb, error, pwd, cnfPwd, saveProcessing } = this.state
    return (
      <div id="mainContainer">
        <div id="designBorder">
        <img src={logo} className="center main-logo"></img>
          <div id="main-page">

            <p style={{ color: 'red' }}>{error}</p>
            <div>
              <div>
                <InputRow
                  rowName="First Name"
                  name="text"
                  value={fname}
                  onChange={(val) => {
                    if (handleAlphabetCheck(val) === 1 || val === '') { this.setState({ fname: val }) } else { alert('Please enter alphabets only!') }
                  }}
                  required="*"

                />
                <InputRow
                  value={lname}
                  rowName="Last Name"
                  name="text"
                  onChange={(val) => this.setState({ lname: val })}
                  required="*"

                />
                <InputRow
                  rowName="Email Address"
                  name="email"
                  value={email}
                  onChange={(val) => this.setState({ email: val })}
                  required="*"
                  hover = "If you have inserted a wrong E-mail, you will not be able to receive a validation."
                />                
                <InputRow
                  rowName="Phone Number"
                  name="phonenb"
                  value={phonenb}
                  onChange={(val) => {
                    if (handleNumberOnlyCheck(val) === 1 || val === '') { this.setState({ phonenb: val }) } else { alert('Please Enter Numbers Only!') }
                  }}
                  required="*"
                />
                <InputRow
                  rowName="Password"
                  name="password"
                  value={pwd}
                  onChange={(val) => this.setState({ pwd: val })}
                  required="*"
                  hover="The password should be greater than 7 characters, containing at least 1 number and at least 1 special (non-alphanumeric) character. "
                />
                <InputRow
                  rowName="Confirm Password"
                  name="password"
                  value={cnfPwd}
                  onChange={(val) => this.setState({ cnfPwd: val })}
                  required="*"
                  onKeyPress={(e) => {
                    if (e.key === 'Enter') {
                      this.handleRegister()
                    }
                  }}
                />
              </div>
            </div>

            <button className="save" onClick={this.handleRegister} disabled={saveProcessing}>
              {saveProcessing ? <img src={submit} alt="Loading..." style={{ width: 18, height: 18 }} /> : 'Submit'}
            </button>
          </div>
        </div>
      </div>
    )
  }
}
Signup.propTypes = {
  onLogin: PropTypes.func.isRequired,
  history: PropTypes.object.isRequired
}
